import { Model } from 'pinia-orm';
import Company from './Company';
import Permission from "./Permission";

export default class Role extends Model {

    static get entity () {
        return 'roles'
    }

    static fields () {
        return {
            id: this.uid(),
            company: this.belongsTo(Company, 'company_id'),
            name: this.attr(''),
            company_id: this.attr(0),
            users_count: this.attr(0),
            pivot: this.attr(null),
            locked: this.attr(false),
            locked_name: this.attr(null),

            permissions: this.morphMany(Permission, 'permissionable_id', 'permissionable_type')
        }
    }
}
